import { inject, Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { ModuleEntity } from '../module.entity';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { LearningUnitEntityService } from '../../learning-unit/services/learning-unit.entity.service';
import { ConsumerEntityService } from '../../consumer/services/consumer.entity.service';
import { SubjectEntityService } from '../../subject/services/subject.entity.service';
import { SchoolClassEntityService } from '../../core/global-enums/school-class/services/school-class.entity.service';
import {
  ModuleLearningUnitMetadataEntityService
} from './module-learning-unit-metadata.entity.service';

export const STATE_NAME = 'moduleEntity';

// Create the NGXS state for modules
export const ModuleEntityState: GenericEntityStateClass<ModuleEntity> =
  createEntityState<ModuleEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ModuleEntityService extends EntityService<ModuleEntity> {
  private learningUnitService = inject(LearningUnitEntityService);
  private consumerEntityService = inject(ConsumerEntityService);
  private subjectEntityService = inject(SubjectEntityService);
  private schoolClassService = inject(SchoolClassEntityService);
  private moduleLearningUnitMetadataService = inject(ModuleLearningUnitMetadataEntityService);

  constructor() {
    super();
    this.resourceType = 'modules';
    this.stateClass = ModuleEntityState;

    this.registerRelation('learning-units', this.learningUnitService);
    this.registerRelation('consumers', this.consumerEntityService);
    this.registerRelation('subjects', this.subjectEntityService);
    this.registerRelation('schoolClasses', this.schoolClassService);
    this.registerRelation('module-learning-unit-metadata', this.moduleLearningUnitMetadataService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ModuleEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
